import React, { useState, useEffect } from 'react'
import { usePageInfo, getPageInfo } from './usePageInfo'

import { useRoom } from './useRoom'

const OptionList = ({ options, sendOption }) => {
    return options.map((option) => <button key={option} onClick={() => { sendOption(option) }}>{option}</button>)
}




const App = () => {
    let [pageInfo, setPageInfo] = usePageInfo();

    let [connState, state, sendOption] = useRoom({ room_id: pageInfo.room_id })

    options = state.Options


    console.log(options)
    return <section>
        <pre>{JSON.stringify(getPageInfo())}</pre>
        <h2>Connection: {connState}</h2>
        <OptionList options={options} sendOption={sendOption} />
        <pre><code>{connState}{"\n"}{JSON.stringify(state)}</code></pre>
    </section>

}

export default App